module.exports = "/shared/img/log-in.png";


//////////////////
// WEBPACK FOOTER
// ./src/ui/img/log-in.png
// module id = 440
// module chunks = 13